import { useQuery } from "react-query";
const SESSIONS_ENDPOINT = "/api/v1/sessions";
const ACCOUNTS_ENDPOINT = "/api/v1/accounts";
function useAuthSession(queryOptions, baseUrl = "") {
  const endpoint = `${baseUrl}${SESSIONS_ENDPOINT}`;
  return useQuery(endpoint, {
    ...queryOptions
  });
}
function useAuthenticatedUser(userIsAuthenticated, queryOptions, baseUrl = "") {
  const endpoint = `${baseUrl}${ACCOUNTS_ENDPOINT}`;
  return useQuery(endpoint, {
    ...queryOptions,
    enabled: queryOptions.enabled || userIsAuthenticated
  });
}
export {
  ACCOUNTS_ENDPOINT,
  SESSIONS_ENDPOINT,
  useAuthSession,
  useAuthenticatedUser
};
//# sourceMappingURL=AuthContextApis.js.map
